import { observer } from 'mobx-react';

import Loader from '@/common/components/Loader/Loader';
import EmptyTreePlaceholder from '@/common/components/TreeItemModal/EmptyTreePlaceholder/EmptyTreePlaceholder';
import BaseDriveModalTree from '@/forwarding/components/ForwardModal/ForwardModalBody/DriveModalTree/BaseDriveModalTree/BaseDriveModalTree';
import { useDriveModalTreeStore } from '@/forwarding/components/ForwardModal/ForwardModalBody/DriveModalTree/DriveModalTreeStore';

import styles from './DriveModalTree.module.css';

function DriveModalTree() {
  const { tree, filteredTree } = useDriveModalTreeStore();

  if (!tree || !filteredTree) {
    return <Loader />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.list}>
        {filteredTree.length === 0 ? (
          <EmptyTreePlaceholder isTreeFilteredOut={tree.length > 0} />
        ) : (
          <BaseDriveModalTree items={filteredTree} />
        )}
      </div>
    </div>
  );
}

export default observer(DriveModalTree);
